export default {
    //意大利语
    DiagnosticReport:'Relazione diagnostica',
    troubleCode:'Codice dei guasti',
    time:'tempo',
    noTItle:'Controllo del produttore',
    TestReport:'Rapporto di prova',
    VehicleInformation:'Informazioni sul veicolo',
    DataStream:'Flusso di dati',
    IMReadiness:'Prontezza I/M',
    Communication:'Protocollo di comunicazione',
    notFaultCode:'Nessun codice di errore',
    nodataflow:'No anomalo flusso di dati',
    PositioningPrompt:'Abilita la funzione di posizionamento per ottenere i prezzi locali.',
    FaultCode:'codice di errore',
    AIDiagnosis:'Diagnosi AI',
    AIWait:'Rapporto AI o in attesa di diagnosi automatica',
    FailedFaultCode:'Impossibile ottenere informazioni sul codice di guasto',
    AIError:'Analisi AI fallita',
    more:'più',
    StoredCodes:'Stored Codes',
    PendingCodes:'Pending Codes',
    PermanentCodes:'Permanent Codes',
    ManufacturerControl:'Controllo del costruttore',
    continue:'continuare',
    // 引导定位
    notlimits:"Non è possibile ottenere l'autorizzazione alla posizione",
    setupSteps:'Impostazione dei passaggi:',
    openset:"Apri l'app Impostazioni",
    findSet:"Trova l'app che stai utilizzando",
    clickset:'Clicca su "Posizione"',
    selectLimits:'Scegliere di utilizzare durante o sempre',
    blackRefresh:"Torna all'app per aggiornare la pagina",
    openAppSet:'Clicca su "Gestione app" o "App"',
    findUseBrowser:'Trova il browser che stai utilizzando',
    clickAuthority:'Clicca su "Gestione autorizzazioni"',
    findejurisd:'Trova il permesso "Posizione"',
    selectjurisd:'Seleziona permetti o permetti quando usato',
    phoneJurisd:"Verificare le autorizzazioni di posizionamento dell'app mobile:",
    openJurisd:'Abilita il permesso di posizione',
    report:'AI',
    AI:'Rapporto'
}